import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\CreateItemController::__invoke
* @see app/Http/Controllers/Item/CreateItemController.php
* @route '/api/item'
*/
const CreateItemController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateItemController.url(options),
    method: 'post',
})

CreateItemController.definition = {
    methods: ["post"],
    url: '/api/item',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Item\CreateItemController::__invoke
* @see app/Http/Controllers/Item/CreateItemController.php
* @route '/api/item'
*/
CreateItemController.url = (options?: RouteQueryOptions) => {
    return CreateItemController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\CreateItemController::__invoke
* @see app/Http/Controllers/Item/CreateItemController.php
* @route '/api/item'
*/
CreateItemController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateItemController.url(options),
    method: 'post',
})

export default CreateItemController